export default __webpack_public_path__ + "static/media/signup.49e79a86.svg";